import { camelizeKeys, camelize } from 'humps';
import getSplashApiClient from 'lib/SplashApiClient/singleton';
import { OWNER_EVENT } from 'common/compounds/FormBuilder/constants/ownerTypes';

export default class FormTemplateLibraryApiClient {
    /**
     * @param {SplashApiClient} apiClient
     */
    constructor(apiClient) {
        this.apiClient = apiClient;
    }

    /**
     * @param {number} [page]
     * @return {Promise}
     */
    getCustomFormTemplates(page = 1, search = '') {
        return this.apiClient
            .get('/form-builder/library/all/custom', {
                page,
                search,
                limit: 30,
            })
            .then(this.formatTemplatesResponse);
    }

    /**
     * @param {string} [entity]
     * @return {Promise}
     */
    getStockFormTemplates(entity = OWNER_EVENT) {
        return this.apiClient.get(`/form-builder/library/question-bank/${entity}`).then(this.formatTemplatesResponse);
    }

    /**
     *
     * @param  {Object} response
     * @return {Object}
     */
    formatTemplatesResponse(response) {
        const camelizedKeysData = camelizeKeys(response.data);

        const templates = camelizedKeysData.map((template) => ({
            ...template,
            data: {
                ...template.data,
                inputType: template.data.inputType ? camelize(template.data.inputType) : template.data.inputType,
            },
        }));

        return {
            templates,
            pagination: response.pagination,
        };
    }

    /**
     * @param {object} question
     * @return {Promise}
     */
    removeQuestionFromFormTemplateLibrary(id) {
        return this.apiClient.delete('/form-builder/library', {
            id,
        });
    }
}

export const getFormTemplateLibraryApiClient = () => new FormTemplateLibraryApiClient(getSplashApiClient());
